import styled from 'styled-components';

export const StyledAmenitiesFilterModal = styled.div``;
